'use strict';

/**
 * Incomplete: Venue is incomplete, should ONLY be visible to authenticated users
 * Review: Venue is to be reviewed by an admin and switched to `Published` or `Private if it passes
 * On Hold: Venue is on hold
 * Partial: A profile that's inclomplete that has been made for sending recos or a booking request
 * Private: Venue is private - anyone can see it but it is `isVisible: false`
 * Published: Venue is published and anyone can see it
 * Hidden: temp status to allow migration
 * Rejected: Temp status to allow migration
 * Venue Closed
 * Venue Fired: We decided not to work with the venue
 * Venue Quit: Venue decided not to work with us
 */
module.exports = ['Incomplete', 'Lite', 'Review', 'Private', 'Published', 'On Hold', 'Unpublished'];

module.exports.invisibleStatuses = ['Incomplete', 'Unpublished'];